import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  CommandColumn,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
  Freeze,
} from "@syncfusion/ej2-react-grids";
import { use } from "react";
import { useNearToExpiryStore } from "../../../store/useNearToExpiryStore";

// 🧠 Generate random mock data
const generateRandomBrokers = (count = 25) => {
  const companies = [
    "TechNova Ltd",
    "BlueOcean Corp",
    "GreenField Traders",
    "Skyline Solutions",
    "FutureWare Pvt Ltd",
    "Prime Logistics",
    "NextEra Inc",
    "DataSphere Global",
    "BrightLink",
    "Zenith Systems",
  ];
  const names = [
    "Amit Verma",
    "Ravi Kumar",
    "Neha Sharma",
    "Sanjay Patel",
    "Priya Mehta",
    "Rahul Singh",
    "Deepa Joshi",
    "Vikram Chauhan",
    "Anjali Nair",
    "Karan Thakur",
  ];

  return Array.from({ length: count }, (_, i) => ({
    serialNo: i + 1,
    name: names[Math.floor(Math.random() * names.length)],
    mobile: "+91 " + Math.floor(9000000000 + Math.random() * 1000000000),
    company: companies[Math.floor(Math.random() * companies.length)],
    address: `#${Math.floor(Math.random() * 300)}, ${
      ["MG Road", "Park Street", "Link Road", "Ring Road", "Sector 18"][
        Math.floor(Math.random() * 5)
      ]
    }, ${
      ["Delhi", "Mumbai", "Bangalore", "Pune", "Chennai"][
        Math.floor(Math.random() * 5)
      ]
    }`,
  }));
};

const BasicGrid = ({}) => {
  const [userDetails, setUserDetails] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const{expiryListAfterApprove}=useNearToExpiryStore();

  useEffect(() => {
    setUserDetails(generateRandomBrokers(40)); // generate 40 random brokers
  }, []);
  let gridInstance;
  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "BrokerGrid_excelexport") {
      gridInstance.excelExport();
    }
  };

  return (
    <>
      <div
        className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
        style={{
          position: "relative",
          marginTop: "10px",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "6px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col>
            <GridComponent
              ref={(g) => (gridInstance = g)}
              id="BrokerGrid"
              dataSource={expiryListAfterApprove}
              allowPaging={true}
              allowSorting={true}
              allowFiltering={true}
              filterSettings={{ type: "Excel" }}
              toolbar={["ExcelExport", "Search"]}
              allowExcelExport={true}
              toolbarClick={toolbarClick}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
              gridLines="Both"
              height={"300px"}
              pageSettings={{
                pageSizes: [10, 20, 30, 40, 50, "All"],
                pageCount: 10,
              }}
              rowHeight={isMobile ? "" : 32}
              // frozenColumns={1}
              // rowDataBound={()}
              // commandClick={handleCommandClick}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="serialNo"
                  headerText="S No"
                  width="90"
                  textAlign="Center"
                  allowFiltering={false}
                />
                <ColumnDirective
                  field="PopulatedDate"
                  headerText="Populated Date"
                  width="200"
                  type="date"
                  format="dd-MM-yyyy"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="LocationCode"
                  headerText="Location Code"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="StoreName"
                  headerText="Store Name"
                  width="230"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="MCcategory"
                  headerText="MC category"
                  width="200"
                  textAlign="Left"
                />
                {/* <ColumnDirective
                  field="Division"
                  headerText="Division"
                  width="170"
                  textAlign="Left"
                /> */}
                <ColumnDirective
                  field="DivisionName"
                  headerText="Division Name"
                  width="170"
                  textAlign="Left"
                />
                {/* <ColumnDirective
                  field="Department"
                  headerText="Department"
                  width="160"
                  textAlign="Left"
                /> */}
                <ColumnDirective
                  field="DepartmentName"
                  headerText="Department Name"
                  width="170"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ArticleCode"
                  headerText="Article Code"
                  width="220"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ShortDesc"
                  headerText="Short Desc"
                  width="230"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="EanPlu"
                  headerText="Ean Plu"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ActualShelfDays"
                  headerText="Actual Shelf Days"
                  width="170"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="name"
                  headerText="One Sixth Shelf Days"
                  width="170"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="StockOnHand"
                  headerText="Stock On Hand"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ManufacturingDate"
                  headerText="Manufacturing Date"
                  width="190"
                  type="date"
                  format="dd-MM-yyyy"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ExpiryType"
                  headerText="Expiry Type"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ExpiryQty"
                  headerText="Expiry Qty"
                  width="170"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ExpiryDate"
                  headerText="Expiry Date"
                  width="150"
                  type="date"
                  format="dd-MM-yyyy"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="MRP"
                  headerText="MRP"
                  width="190"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="CSP"
                  headerText="CSP"
                  width="190"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ScanQty"
                  headerText="Scan Qty"
                  width="190"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ScanOn"
                  headerText="Scan On"
                  type="date"
                  format="dd-MM-yyyy"
                  width="190"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ApprovedQty"
                  headerText="Approved Qty"
                  width="190"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ApprovedBy"
                  headerText="Approved By"
                  width="190"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ApprovedOn"
                  headerText="Approved On"
                  type="date"
                  format="dd-MM-yyyy"
                  width="190"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="PrintQty"
                  headerText="Print Qty"
                  width="190"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="PrintBy"
                  headerText="Print By"
                  width="190"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="PrintOn"
                  headerText="Print On"
                  type="date"
                  format="dd-MM-yyyy"
                  width="190"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Discount"
                  headerText="Discount"
                  width="190"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="IsActive"
                  headerText="IsActive"
                  width="190"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="UploadedOn"
                  headerText="UploadedOn"
                  type="date"
                  format="dd-MM-yyyy"
                  width="190"
                  textAlign="Left"
                />

              </ColumnsDirective>

              <Inject
                services={[
                  CommandColumn,
                  Page,
                  Filter,
                  Toolbar,
                  ExcelExport,
                  Sort,
                  Group,
                  Resize,
                  Freeze,
                ]}
              />
            </GridComponent>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default BasicGrid;
